import { Box, Typography } from '@mui/material';
import useAppTheme from 'hooks/useAppTheme';
import { ThemePalette } from 'mui.theme';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

const NoData = ({
  height,
  width,
  text,
  textFontSize,
}: {
  height?: string | number;
  width?: string | number;
  textFontSize?: string | number;
  text?: string;
}) => {
  const enableDarkTheme = useAppTheme();
  const palette = enableDarkTheme
    ? clientThemePalette[CLIENT_THEME].dark
    : clientThemePalette[CLIENT_THEME].light;
  const textColor = enableDarkTheme
    ? ThemePalette.typography.lightGrey
    : ThemePalette.typography.lightGrey; // right now same color, but if needed can be changed later
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: height ?? '100%',
        width: width ?? '100%',
        textAlign: 'center',
        padding: '20px',
        borderRadius: '8px',
        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
      }}
    >
      <Typography
        sx={{
          marginBottom: '10px',
          fontWeight: 'bold',
          color: textColor,
          fontSize: textFontSize ?? '16px',
        }}
      >
        {text ?? 'No Data Available!'}
      </Typography>
    </Box>
  );
};

export default NoData;
